import remove from 'lodash/remove';
import api from '@/api';

export default {
  namespaced: true,

  state: {
    measuringPoints: [],
  },

  actions: {
    async AddMeasuringPoint({ commit }, form) {
      const { measuringPoint } = await api.measuringPoint.addMeasuringPoint({ ...form });
      commit('ADD_MEASURINGPOINT', measuringPoint);
      return measuringPoint;
    },
    async UpdateMeasuringPoint({ commit }, form) {
      const { measuringPoint } = await api.measuringPoint.putMeasuringPoint({ ...form });
      commit('UPDATE_MEASURINGPOINT', measuringPoint);
      return measuringPoint;
    },
    // 创建组合测点
    async AddMasterMeasuringPoint({ commit }, form) {
      const { measuringPoint } = await api.measuringPoint.addMasterMeasuringPoint({ ...form });
      commit('ADD_MEASURINGPOINT', measuringPoint);
      return measuringPoint;
    },
    // 更新组合测点
    async UpdateMasterMeasuringPoint({ commit }, form) {
      const { measuringPoint } = await api.measuringPoint.putMasterMeasuringPoint({ ...form });
      commit('UPDATE_MEASURINGPOINT', measuringPoint);
      return measuringPoint;
    },
    async UpdateMeasuringPointCollectConfig({ commit }, form) {
      const { measuringPoint, updateTips } = await api.measuringPoint.patchMeasuringPointCollectConfig({ ...form });
      commit('UPDATE_MEASURINGPOINT', measuringPoint);
      return { measuringPoint, updateTips };
    },
    async DeleteMeasuringPoint({ commit }, item) {
      await api.measuringPoint.deleteMeasuringPoint({
        projectId: item.projectId,
        structureId: item.structureId,
        measuringPointId: item.id,
      });
      commit('DELETE_MEASURINGPOINT', item);
    },
  },
  mutations: {
    ADD_MEASURINGPOINT(state, measuringPoint) {
      const { measuringPoints } = state;
      state.measuringPoints = [...measuringPoints, measuringPoint];
    },
    UPDATE_MEASURINGPOINT(state, measuringPoint) {
      const { measuringPoints } = state;
      const target = measuringPoints.find(item => item.id === measuringPoint.id);

      if (target) {
        Object.assign(target, measuringPoint);
        state.measuringPoints = [...measuringPoints];
      }
    },
    DELETE_MEASURINGPOINT(state, measuringPoint) {
      const { measuringPoints } = state;
      remove(measuringPoints, item => item.id === measuringPoint.id);
      state.structures = [...measuringPoints];
    },
  },
};
